// Конфигурация API
export const API_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://api.revuai.site"
      : "http://localhost:3001"),
  // Временный флаг для отключения realtime (WebSocket/Socket.IO)
  REALTIME_ENABLED: true,
  WS_BASE_URL:
    process.env.REACT_APP_WS_URL ||
    (process.env.NODE_ENV === "production"
      ? "wss://bbagrlo44d433555dlvi.containers.yandexcloud.net"
      : "ws://localhost:3001"),
  ENDPOINTS: {
    // Auth
    LOGIN: "/api/auth/login",
    REGISTER: "/api/auth/register",
    REFRESH: "/api/auth/refresh",

    // Users
    PROFILE: "/api/users/profile",

    // Ozon Products and Reviews
    PRODUCTS: "/api/products",
    OZON_PRODUCTS: "/api/ozon-products",
    OZON_PRODUCT_DESCRIPTION: "/api/ozon-products/description",
    OZON_PRODUCT_DETAIL: "/api/ozon-products/detail",
    OZON_PRODUCT_ATTRIBUTES: "/api/ozon-products/attributes",
    OZON_PRODUCT_REVIEWS: "/api/ozon-products/reviews",
    OZON_PRODUCT_REVIEWS_DB: "/api/ozon-products/reviews-db",
    UNIVERSAL_PRODUCT_INFO: "/api/universal-products/info",
    UNIVERSAL_PRODUCT_REVIEWS: "/api/universal-products/reviews",
    UNIVERSAL_PRODUCT_RATING_STATS: "/api/universal-products/rating-stats",
    UNIVERSAL_PRODUCT_RATING_STATS_RECENT:
      "/api/universal-products/rating-stats/recent",
    UNIVERSAL_PRODUCT_ANALYSIS: "/api/universal-products/analysis",
    OZON_REVIEW_COUNT: "/api/reviews-list/count",
    OZON_ALL_REVIEWS: "/api/reviews-list/all",
    OZON_FILTERED_REVIEWS: "/api/reviews-list/filtered",
    OZON_REVIEWS: "/api/ozon-reviews",
    YANDEX_REVIEWS: "/api/yandex-reviews",
    UNIVERSAL_FILTERED_REVIEWS: "/api/universal-reviews/filtered",

    // Wildberries Products and Reviews
    WILD_PRODUCTS: "/api/wild-products",
    WILD_PRODUCT_DESCRIPTION: "/api/wild-products/description",
    WILD_PRODUCT_DETAIL: "/api/wild-products/detail",
    WILD_PRODUCT_ATTRIBUTES: "/api/wild-products/attributes",
    WILD_PRODUCT_REVIEWS: "/api/wild-products/reviews",
    WILD_PRODUCT_REVIEWS_DB: "/api/wild-products/reviews-db",
    WILD_REVIEW_COUNT: "/api/reviews-list/count",
    WILD_ALL_REVIEWS: "/api/reviews-list/all",
    WILD_FILTERED_REVIEWS: "/api/reviews-list/filtered",
    WILDBERRIES_REVIEWS: "/api/wildberries-reviews",

    // Reviews
    REVIEWS: "/api/reviews",
    ADD_TEST_PRODUCTS: "/api/reviews/add-test-products",
    CLEAR_ALL: "/api/reviews/clear-all",
    GENERATE_RESPONSES: "/api/reviews/generate-all-responses",

    // Analytics
    ANALYTICS: "/api/analytics",
    AVERAGE_RATING: "/api/analytics/average-rating-over-time",

    // AI
    AI: "/api/ai",
    EXTERNAL_REVIEW_AI_ANALYZE: "/api/external-review-ai/analyze",
    EXTERNAL_REVIEW_AI_RESPONSE: "/api/external-review-ai/response",
    EXTERNAL_REVIEW_AI_RESPONSE_PREVIEW:
      "/api/external-review-ai/response-preview",
    EXTERNAL_REVIEW_AI_ANALYSIS: "/api/external-review-ai/analysis",

    // Publish seller responses per platform
    PUBLISH_EXTERNAL_REVIEW_RESPONSE:
      "/api/external-review-ai/publish-response",

    // API Testing
    TEST_CONNECTION: "/api/api-test/test-connection",
    SYNC_REVIEWS: "/api/api-test/sync-reviews",

    // Stores
    STORES: "/api/stores",

    // Templates
    TEMPLATES: "/api/templates",
  },
};

// Функция для получения полного URL
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
